import { isValidKennitala, isValidKennitalaInput } from '@/utils/utils';
import { InputState } from 'components/src/textInput';
import { useState } from 'react';
import TextInput from '../../../../../packages/components/src/textInput/TextInput';
import * as React from 'react';

type Props = {
  id: string;
  name: string;
  label?: string;
  setValidationError?: (hasError: boolean) => void;
  placeholder: string;
  onChange?: (value: string) => void;
};

const KennitalaInput = ({ id, name, label, setValidationError, placeholder, onChange }: Props) => {
  const [inputState, setInputState] = useState<InputState>();
  const [inputValue, setInputValue] = useState<string>('');

  const onBlur = () => {
    if (inputValue && !isValidKennitala(inputValue)) {
      setInputState({
        type: 'error',
        message: 'Kennitala er ekki á réttu formi. Hún skal vera 10 tölustafir án bandstriks.',
      });
      if (setValidationError) setValidationError(true);
    } else {
      setInputState(undefined);
    }
  };

  const handleChange = (value: string) => {
    if (isValidKennitalaInput(value)) {
      // Clear error state if input is valid
      if (isValidKennitala(value)) {
        setValidationError && setValidationError(false);
      }
      setInputValue(value);
      onChange && onChange(value);
    }
  };

  return (
    <TextInput
      id={id}
      name={name}
      label={label}
      placeholder={placeholder}
      type="tel"
      inputState={inputState}
      onBlur={onBlur}
      onChange={handleChange}
      value={inputValue}
    />
  );
};

export default KennitalaInput;
